import ROUTE_CONSTANTS from "../constants/RouteConstants";
import { REDIRECTION_SOURCES } from '../constants'

export const reloadPageToLoginView = () => {
    const path = window.location.pathname;
    window.location.replace(`${ROUTE_CONSTANTS.LOGIN_VIEW}?continue=${path}`);
  };  

export const closeWebView = () => (document.location.href = 'exit_webview');

export const openParentWindow = source => {
    if (source === REDIRECTION_SOURCES.ANDROID) {
        closeWebView();
    }
    // window.opener.focus() so this is a workaround if found any ideal solution please suggest
    else if (window.opener) {
        window.opener.name = 'oyo-os-home';
        window.open(window.opener.location.href, window.opener.name);
        window.opener.focus();
        window.close();
    } else reloadPageToLoginView();
    // window.opener && window.opener.focus();
};